/** @format */

import {WidgetStat} from 'components/PropertyWidget/model';
import {ValueBox} from 'components/PropertyWidget/style';

import {CommonChartData} from 'components/charts/multiline-chart/model/charts';
import WidgetFormattedNumber from 'components/PropertyWidget/components/WidgetFormattedNumber';

import {sumSeries} from 'features/mediaplan-progress/helpers/sumSeries';

import {factSeriesFromChartData} from '../progress-adapter/seriesFromChartData';
import {LogWidgetButton} from '../../components/logs/log-widget-button';

export interface GetStatsTypeScatterOptions {
  data: CommonChartData[];
  startDate: string;
  endDate: string;
}

const getStatsTypeScatterLogs = ({
  data,
  startDate,
  endDate,
}: GetStatsTypeScatterOptions): WidgetStat[] => {
  const fact = sumSeries(factSeriesFromChartData(data));

  return [
    {
      heading: 'За период',
      ValueComponent: (
        <ValueBox>
          <WidgetFormattedNumber number={fact} />
        </ValueBox>
      ),
      dontDrawDividerAfter: true,
    },
    {
      heading: <LogWidgetButton startDate={startDate} endDate={endDate} />,
    },
  ];
};

export {getStatsTypeScatterLogs};
